import { useRef, useEffect } from 'react'

import styles from './404.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'

function PageNotFound(props) {
	const heroRef = useRef(null)
	const fields = props.fields

	useEffect(() => {

		if(fields.style == "large"){
			const topPos = heroRef.current.getBoundingClientRect().top + window.scrollY + 100
			heroRef.current.parentElement.style.height = 'calc(100vh - ' + topPos + 'px)'
		}

		if(fields.style == "full_screen"){
			const topPos = heroRef.current.getBoundingClientRect().top + window.scrollY
			heroRef.current.parentElement.style.height = 'calc(100vh - ' + (topPos - 1) + 'px)'
		}
	}, [])

	return <BlockWrapper {...props} className={classNames(styles.hero, styles[fields.style])}>
		<div ref={heroRef}>
			<ScrollAnimation styles={styles}>
				<Media {...fields.media} settings={{texture: (fields.media.disable_grain_effect ? false : true), loading: 'eager'}} className={styles.media} />
				{fields.title &&
					<div className={styles.content_wrapper}>
						<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.title}}></div>
					</div>
				}
				<div className={styles.scroll_down}>
					<a onClick={e => {
						let anchor = document.getElementById("anchor")
						e.preventDefault()
						anchor && anchor.scrollIntoView({ behavior: "smooth", block: "start"})
						}}
					>
					</a>
				</div>
			</ScrollAnimation>
		</div>
	</BlockWrapper>
}

export default PageNotFound